import request from "@/utils/request";
import { IEviApp } from "../model/eviapp";

// 实体
export const defaultEviAppData: IEviApp = {
  id: "",
  appName: "",
  app_Key: "",
  app_Secret: "",
  appType: 1,
  platformType: 1,
  memberId: "",
  createTime: 0,
  updateTime: 0,
  whiteList: ""
};

export const getEviApp = (id: any) => {
  request({
    url: "/EviApp/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviApp = (data: any) =>
  request({
    url: "/EviApp/Add",
    method: "post",
    data
  });

export const updateEviApp = (data: any) =>
  request({
    url: "/EviApp/Update",
    method: "post",
    data
  });

export const deleteEviApp = (id: string) =>
  request({
    url: "/EviApp/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviAppPageList = (data: any) =>
  request({
    url: "/EviApp/GetPageListAsync",
    method: "post",
    data
  });

export const getCurrentAppArr = () =>
  request({
    url: "/EviApp/GetCurrentAppArr",
    method: "post"
  });
